<template>
  <div :class="$style.container">
    <div :class="$style.innerContainer">
      <div :class="$style.detailsContainer">
        <GameDetailsBox
          :host="host"
          :playersJoined="playersJoined"
          :discussionTime="discussionTime"
          :readingTime="readingTime"
        />
      </div>

      <div :class="$style.waitContainer">
        <img :src="joinLoaderGif" alt="loader" :class="$style.waitLoader" />
        <div :class="$style.waitText">{{ $t('wait-for-host') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import styles from "@/css/PlayerJoinWaitBox.module.css";
import globalStyles from "@/css/global.module.css";
import JoinLoaderGif from "@/assets/gifs/join-loader.svg";
import GameDetailsBox from "./GameDetailsBox.vue";

export default {
  components: { GameDetailsBox },
  name: "PlayerJoinWaitBox",
  props: {
    host: {
      type: Object,
      required: true,
    },
    // allowedPlayers: {
    //   type: Number,
    //   required: true,
    // },
    playersJoined: {
      type: Number,
      required: false,
      default: 0
    },
    discussionTime: {
      type: Number,
      required: true,
    },
    readingTime: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      joinLoaderGif: JoinLoaderGif,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
